<div class="table table-responsive">
        <table class="table">
        <thead>
            <tr class="custom-table-head">
                <th>
                    <a style="cursor: pointer" (click)="currentPage = 0; getItems()" title="Actualiser">
                        <i class="fa fa-redo-alt"></i></a>&nbsp;&nbsp; #
                </th>
                <th>Matricule</th>
                <th>Nom Prenom</th>
                <th>Statut</th>
                <th>Date entrée</th>
                <th>Prime de base</th>
                <th>Prime net(prorata)</th>
                <th>Surprime</th>
                <th>Surprime affection</th>
                <th>Acc. global</th>
                <th>Acc. gest.</th>
                <th>Acc. garant</th>
                <th>Acc. interm.</th>
                <th>Com. commercial</th>
                <th>Com. intermediaire</th>
                <!-- <th>Acc. apporteur</th>
                <th>Acc. sousc.</th>
                <th>Acc. courtier</th> -->
                <th>Prime TTC</th>
                <th>Plafond</th>
                <th class="txt-align-center">Photo</th>
            </tr>
        </thead>

        <tbody>
            <tr [class.isAssure]="item?.statut_codification =='A'" [class.isSupplementaire]="item?.is_supplementaire" 
                *ngFor="let item of items; let indice = index">
                <td class="txt-align-center">{{ currentPage>1?(((currentPage - 1) * this.itemsPerPage) + (indice+1)):indice+1 }}</td>
                <td>{{ item?.matricule }}</td>
                <td>{{ item?.beneficiaire_nom }} {{ item?.beneficiaire_prenom }}</td>
                <td>{{ item?.statut_codification }}</td>
                <td>{{ item.date_entree?(item?.date_entree | dateFormat):'' }}</td>
                <td>{{ item?.prime_non_prorata | roundDecimal:2 |mask:'separator' }}</td>
                <td>{{ item?.prime | roundDecimal:2 |mask:'separator' }}</td>
                <td>{{ item?.surprime | roundDecimal:2 |mask:'separator' }}</td>
                <td>{{ item?.surprime_affection | roundDecimal:2 |mask:'separator' }}</td>
                <td>{{ item?.accessoire_global | roundDecimal:2 |mask:'separator' }}</td>
                <td>{{ item?.accessoire_gestionnaire | roundDecimal:2 |mask:'separator' }}</td>
                <td>{{ item?.accessoire_garant | roundDecimal:2 |mask:'separator' }}</td>
                <td>{{ item?.accessoire_intermediaire | roundDecimal:2 |mask:'separator' }}</td>
                <!-- <td>{{ item?.accessoire_apporteur | roundDecimal:2 |mask:'separator' }}</td>
                <td>{{ item?.accessoire_souscripteur | roundDecimal:2 |mask:'separator' }}</td>
                <td>{{ item?.accessoire_courtier | roundDecimal:2 |mask:'separator' }}</td> -->
                <td>{{ item?.commission_commercial | roundDecimal:2 |mask:'separator' }}</td>
                <td>{{ item?.commission_intermediaire | roundDecimal:2 |mask:'separator' }}</td>
                <td>{{ item?.prime_ttc | roundDecimal:2 |mask:'separator' }}</td>
                <td>{{ item?.plafond | roundDecimal:2 |mask:'separator' }}</td>
                <td>
                    <img [src]="item.beneficiaire_image_url | safe" (error)="handleImageError(item)" 
                         style="width: 30px; height: 30px; display: block; border-radius: 50px;" />
                </td>
            </tr>
        </tbody>

        <tfoot>
            <tr *ngIf="items && items.length > 0">
                <td colspan="19"> <!-- Updated colspan to match total columns -->
                    <div class="row pagination-part">
                        <div class="col-md-9" style="text-align: center">
                            <pagination [maxSize]="5" [boundaryLinks]="true" [itemsPerPage]="itemsPerPage"
                                [totalItems]="totalItems" [(ngModel)]="currentPage" class="pagination-sm"
                                previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"
                                (pageChanged)="pageChanged($event)">
                            </pagination>
                        </div>

                        <div class="col-md-3">
                            <div class="paginator-per-page">
                                <app-element-by-page-paginator (paginationChange)="changePaginationSize($event)"
                                    [defaultItemPerPage]="itemsPerPage">
                                </app-element-by-page-paginator>

                                <span class="span_total_entree pull-right">Total : {{ totalItems }}</span>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>

            <tr *ngIf="!items || items.length == 0">
                <td colspan="19"> <!-- Updated colspan to match total columns -->
                    <div class="col-md-12 txt-align-center">
                        Aucune donnée disponible
                    </div>
                </td>
            </tr>
        </tfoot>
    </table>
</div>